/* src/app/shared/contract/contract-seller-list/contract-seller-list.component.scss */
.main-container-wrapper {
  background-color: #FFF;
  padding: 5px;
}
.main-container {
  background-color: #001A33;
  border-radius: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 10px);
  align-items: stretch;
  width: 100%;
}
.title {
  font: 700 18px FranceTV Brown;
  color: #DFEBF7;
}
.screens-filter-container {
  background-color: #1F364D;
  border-radius: 16px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 25px 25px 25px;
  gap: 15px;
}
/*# sourceMappingURL=contract-seller-list.component.css.map */
